module.exports = __webpack_public_path__ + "media/images/point/points-f8565f75f00c6b055c53ed4e6a518132.png";